/* eslint-disable */
function getLoadDriftWidget(driftInstanceIdentifier) {
    // https://gethelp.drift.com/hc/en-us/articles/360019504134-Drift-Load-Time-and-Supported-Browsers
    function LoadDriftWidget() {
        var t = (window.driftt = window.drift = window.driftt || []);
        if (!t.init) {
            if (t.invoked)
                return void (window.console && console.error && console.error("Drift snippet included twice."));
            (t.invoked = !0),
                (t.methods = ["identify", "config", "track", "reset", "debug", "show", "ping", "page", "hide", "off", "on"]),
                (t.factory = function (e) {
                    return function () {
                        var n = Array.prototype.slice.call(arguments);
                        return n.unshift(e), t.push(n), t;
                    };
                }),
                t.methods.forEach(function (e) {
                    t[e] = t.factory(e);
                }),
                (t.load = function (t) {
                    var e = 3e5, n = Math.ceil(new Date() / e) * e, o = document.createElement("script");
                    (o.id = "driftWidgetScriptTag"), (o.type = "text/plain"), (o.className = "trustecm"), (o.setAttribute("trackertype", "chat")), (o.async = !0), (o.crossorigin = "anonymous"), (o.dataset.src = "https://js.driftt.com/include/" + n + "/" + t + ".js");
                    var i = document.getElementsByTagName("script")[0];
                    i.parentNode.insertBefore(o, i);
                });
        }
        drift.SNIPPET_VERSION = "0.3.1";
        drift.load(driftInstanceIdentifier);
    }
    return LoadDriftWidget;
}
export { getLoadDriftWidget };
